import { Component, Inject, ViewChild, ViewEncapsulation} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { IAtp } from 'app/models/atp/atp';
import { IAddress } from 'app/models/common/address';
import { IAccountAffiliation } from 'app/models/common/account-affiliation';
import { AtpService } from 'app/services/atp/atp.service';
import { SharedService } from 'app/services/core/shared.service';
import { ToastrService } from 'ngx-toastr';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ANIMATIONS, LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { ICourseFilter } from 'app/models/filters/course-filter';
import { IAtpCourse } from 'app/models/atp/atp-course';
import { IAtpAccreditation } from 'app/models/atp/atp-accreditation';
import { AtpEditCourseComponent } from '../atp-edit-course/atp-edit-course.component';
import { CommonService } from 'app/services/common/common.service';
import { AtpEditStaffComponent } from '../atp-edit-staff/atp-edit-staff.component';
import { AtpApplicationListComponent } from '../atp-application-list/atp-application-list.component';
import { AtpApplicationComponent } from '../atp-application/atp-application.component';
import { StaffAffiliationRequestDialogComponent } from '../../common/staff-affiliation-request-dialog/staff-affiliation-request-dialog.component';
import { ConfirmationDialogueComponent } from '../../common/confirmation-dialogue/confirmation-dialogue.component';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-atp-edit',
  templateUrl: './atp-edit.component.html',
  styleUrls: ['./atp-edit.component.scss'],
  animations: ANIMATIONS,
  encapsulation: ViewEncapsulation.None
})
export class AtpEditComponent {
  private static readonly delinquentDaysStart = 10;
  private static readonly delinquentDaysEnd = 14;

  public loading: boolean = true;
  public isMobile: boolean = false;
  public showHistory: boolean = false;
  public selectedTabIndex: number = 0;
  public uiData = LEAD_BASED_PAINT;
  public accreditationStatusOptions = [];//Object.values(ACCREDITATION_STATUS);
  public atp: any = {};//public atp: IAtp = {id: 0, atporId: '', name: '', nameAKA: '', privateCompany: false, inactive: false, rrpAccredStatus: ACCREDITATION_STATUS.none, lbpaAccredStatus: ACCREDITATION_STATUS.none, firm: null, accreditations: null, outOfState: false};
  public atpForm = null;  
  public addressForm = null;  
  public addressInformation: IAddress = {id:0, contactType:'Work', street:'',city:'',state:'',county:'',zip:''};
  public atpAddressInformation: any = {id: 0, address: this.addressInformation, atp: null, isCurrentMailing: true, isCurrentPhysical: true};//public atpAddressInformation: IAtpAddress = {id: 0, address: this.addressInformation, atp: null, isCurrentMailing: true, isCurrentPhysical: true};
  public contactForm = null;
  public contactInformation: any = {id: 0,contactType:'Work',phone:'',fax:'',cell:'',website:'',ext:'',email:'', label:''};//public contactInformation: IContactInformation = {id: 0,contactType:'Work',phone:'',fax:'',cell:'',website:'',ext:'',email:'', label:''};
  public atpContactInformation: any = {id: 0,atp:null,contactInformation: this.contactInformation};//public atpContactInformation: IAtpContactInformation = {id: 0,atp:null,contactInformation: this.contactInformation};

  public courseFilter: ICourseFilter = {    
    filterCourseString: null,
    filterATPString: null,         
    filterStartDate: null,
    filterEndDate: null,
    filterDelinquents: true,
    filterATPId: null,
    filterDateType: null,
  };

  public atpCoursesLoading = true;
  public atpCourses: IAtpCourse[] = [];
  public courseStatusQuickFilter: 'feedback' | 'delinquent' | 'missingPostNotification' | 'pendingApproval' | null = null;

  public atpStatusCounts = {
    courses: {
      feedback: 0,
      delinquent: 0,
      missingPostNotification: 0,
      pendingApproval: 0,
    },
    applications: {
      feedback: 0,
      pendingApproval: 0,
      inProgress: 0,
    }
  };
  public atpCourseTable = 
  {
    layout:{
      columns:['location','accreditationDiscipline', 'courseStart', 'stage', 'receivedStudentFees', 'receivedPreNote','receivedPostNote','cancelled'],
      container:[        
        {displayName:'Location',columnName:'location', type:'number', size:'18'}, 
        {displayName:'Discipline',columnName:'accreditationDiscipline', type:'string', size:'18'},
        {displayName:'Start/End Date',columnName:'courseStart', type:'date', size:'14'},
        {displayName:'Course Type',columnName:'stage', type:'string', size:'12'},
        {displayName:'Payment Received',columnName:'receivedStudentFees', type:'bool', size:'10'},
        {displayName:'Pre Note Received',columnName:'receivedPreNote', type:'bool', size:'10'},
        {displayName:'Post Note Received',columnName:'receivedPostNote', type:'bool', size:'10'},
        {displayName:'Cancelled',columnName:'cancelled', type:'bool', size:'8'},
      ],
      data: []      
    }
  };
  public atpCourseTablePageSize = 5;
  public atpCourseDataSource: MatTableDataSource<any>;
  public filterATPCourseString: string = '';  
  public filterATPCourseDisciplines = new FormControl([]);
  public filterATPCoursePreNote = new FormControl([]);
  public filterATPCoursePostNote = new FormControl([]);
  public filterATPCourseCancelled = new FormControl([]);
  public filterATPDateType = new FormControl('Course Start');
  public filterStartDate = new Date(new Date().setMonth(new Date().getMonth() - 6));
  public filterEndDate = null;
  public atpCourseDisciplines = [];//Object.values(COURSE_DISCIPLINES);
  public atpCourseNoteBooleans = Object.values(['Not Received','Received']);
  public atpCourseCancelled = Object.values(['Cancelled','Active']);
  public changeIndicator: number = 0;
  @ViewChild('CourseTablePaginator') atpCoursePaginator: MatPaginator;
  @ViewChild('CourseTableSort') atpCourseSort: MatSort;

  public atpStaffLoading = true;
  public atpStaff: any[] = [];//public atpStaff: IAtpPerson[] = [];
  public atpStaffRows: any[] = [];
  public atpStaffTable = 
  {
    layout:{
      columns:['displayName', 'requestStatus', 'isContact', 'isInstructor','isPrimaryInstructor','isTrainingManager'],
      container:[                 
        {displayName:'Name',columnName:'displayName', type:'string', size:'24'},
        {displayName:'Status',columnName:'requestStatus', type:'string', size:'12'},
        {displayName:'Point of Contact',columnName:'isContact', type:'bool', size:'13'},
        {displayName:'Instructor',columnName:'isInstructor', type:'bool', size:'13'},
        {displayName:'Primary Instructor',columnName:'isPrimaryInstructor', type:'bool', size:'17'},
        {displayName:'Training Manager',columnName:'isTrainingManager', type:'bool', size:'17'},        
      ],
      data: []      
    }
  };
  public atpStaffTablePageSize = 5;
  public filterATPStaffString: string = '';
  public filterATPStaffPOC = new FormControl([]);
  public filterATPStaffInstructor = new FormControl([]);
  public filterATPStaffPrimaryInstructor = new FormControl([]);
  public filterATPStaffTrainingManager = new FormControl([]);
  public atpStaffBoolList = Object.values(['Unchecked','Checked']);
  public atpStaffDataSource: MatTableDataSource<any>;
  @ViewChild('StaffTablePaginator') atpStaffPaginator: MatPaginator;
  @ViewChild('StaffTableSort') atpStaffSort: MatSort;

  public userAccounts: any[] = [];
  public userAccountsDataSource: MatTableDataSource<any>;
  public userAccountTable = 
  {
    layout:{
      columns:['userName', 'userID', 'status', 'requestedStatus', 'lastUpdatedBy', 'actions'],
      container:[        
        {displayName:'User Name',columnName:'userName', type:'string', size:'20'}, 
        {displayName:'User Email',columnName:'userID', type:'string', size:'25'},
        {displayName:'Status',columnName:'status', type:'string', size:'15'},
        {displayName:'Requested Status',columnName:'requestedStatus', type:'string', size:'15'},
        {displayName:'Requested By',columnName:'lastUpdatedBy', type:'string', size:'15'}        
      ],
      data: []      
    }
  };
  public userAccountTablePageSize = 5;
  public filterUserAccountString: string = '';
  @ViewChild('UserAccountTablePaginator') userAccountPaginator: MatPaginator;
  @ViewChild('UserAccountTableSort') userAccountSort: MatSort;

  public atpAccreditationLoading = true;
  public atpAccreditation: IAtpAccreditation[] = [];
  public atpAccreditationTable = 
  {
    layout:{
      columns:['accreditationEndorsementType', 'expirationDate', 'actions'],
      container:[        
        {displayName:'Endorsement',columnName:'accreditationEndorsementType', type:'string', size:'55'},
        {displayName:'Expiration Date',columnName:'expirationDate', type:'date', size:'20'},
      ],
      data: []      
    }
  };
  public atpAccreditationTablePageSize = 5;
  public filterATPAccreditationString: string = '';
  public filterAccreditationStartDate = null;
  public filterAccreditationEndDate = null;    
  public atpAccreditationDataSource: MatTableDataSource<any>;
  @ViewChild('AccreditationTablePaginator') atpAccreditationPaginator: MatPaginator;
  @ViewChild('AccreditationTableSort') atpAccreditationSort: MatSort;
  @ViewChild('atpApplicationListComponent') atpApplicationListComponent: AtpApplicationListComponent;
  
  public atpApplicationLoading = true;
  public atpApplicationCount = 0;
  public applicationTargetContext: any = null;
  private applicationTargetContextLoading: boolean = false;
  private applicationTargetContextSignature: string = '';
  
  public cardColor: string = this.sharedService.gold + '20';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {atp: IAtp, atpId: number},    
    public commonService: CommonService,
    private readonly toastr: ToastrService,
    private readonly atpService: AtpService,    
    public sharedService: SharedService,
    // public paymentService: PaymentService,
    public dialog: MatDialog,
    private readonly breakpointObserver: BreakpointObserver,    
    ) 
    { 
    this.data.atpId = this.data.atpId || 0;    
    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet,
      Breakpoints.Small,
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.setAtpFormFields();        
    this.atp = this.data.atp ?? this.atp;    
    this.loadATPFields();

    if(this.data.atpId !== 0 || this.atp?.id !== 0){
      let id = this.data.atpId || this.atp.id;
      this.atpService.getAtpById(id).subscribe(result=>{
        this.atp = result;
        this.loadATPFields();
        this.refreshATPAddresses();
        this.refreshATPContactInformation();
        this.refreshStaffMembers();
        this.refreshUserAccounts();
        this.refreshCourses();
        this.refreshAccreditation();
        
        // Refresh the application list if it's available
        setTimeout(() => {
          if (this.atpApplicationListComponent) {
            this.atpApplicationListComponent.loadData();
          }
        }, 0);
        
        this.loading = false;
      },error=>{
        this.toastr.error("There was an error getting the ATP: ", error);
        this.loading = false;
      })
      this.loading = false;  
    }  
    else
      this.loading = false;  
  }

  statusColor(status: string): string {
    return this.sharedService.getStatusColor(status);
  }

  onApplicationCountChanged(count: number): void {
    this.atpApplicationCount = count;
    this.atpApplicationLoading = false;
    this.refreshAtpStatusCounts();
    this.preloadApplicationTargetContext();
  }

  private toDateOnly(value: Date): Date {
    const dateOnly = new Date(value);
    dateOnly.setHours(0, 0, 0, 0);
    return dateOnly;
  }

  private isNonEmptyText(value: unknown): boolean {
    return (value ?? '').toString().trim().length > 0;
  }

  private preloadApplicationTargetContext(): void {
    const atpId = this.atp?.id;
    if (!atpId || this.atpAccreditationLoading || this.atpApplicationLoading) {
      return;
    }

    const accreditations = this.atpAccreditation || [];
    const applicationIds = (this.atpApplicationListComponent?.getAllApplications() || [])
      .map((application: any) => application?.id)
      .filter((id: any) => !!id)
      .sort((left: number, right: number) => left - right);

    const signature = `${atpId}|${accreditations.map(accreditation => accreditation?.id || 0).sort((left, right) => left - right).join(',')}|${applicationIds.join(',')}`;
    if (this.applicationTargetContextLoading && this.applicationTargetContextSignature === signature) {
      return;
    }

    if (this.applicationTargetContext && this.applicationTargetContextSignature === signature) {
      return;
    }

    this.applicationTargetContextLoading = true;
    this.applicationTargetContextSignature = signature;

    if (applicationIds.length === 0) {
      this.applicationTargetContext = {
        atpId,
        accreditations,
        applications: []
      };
      this.applicationTargetContextLoading = false;
      return;
    }

    forkJoin(
      applicationIds.map(id =>
        this.atpService.getAtpApplication(id).pipe(
          catchError(error => {
            console.error('Error preloading ATP application target context:', error);
            return of(null);
          })
        )
      )
    ).subscribe({
      next: (applications) => {
        this.applicationTargetContext = {
          atpId,
          accreditations,
          applications: applications.filter((application: any) => !!application)
        };
        this.applicationTargetContextLoading = false;
      },
      error: () => {
        this.applicationTargetContextLoading = false;
      }
    });
  }

  private daysSince(dateIso: string | Date | null | undefined): number | null {
    if (!dateIso) {
      return null;
    }
    const dateValue = this.toDateOnly(new Date(dateIso));
    const today = this.toDateOnly(new Date());
    const diffMs = today.getTime() - dateValue.getTime();
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
  }

  private refreshAtpStatusCounts(): void {
    this.atpStatusCounts.courses = this.computeCourseStatusCounts(this.atpCourses);

    const applications = (this.atpApplicationListComponent as any)?.getAllApplications?.() ?? [];
    this.atpStatusCounts.applications = this.computeApplicationStatusCounts(applications);
  }

  private computeCourseStatusCounts(courses: IAtpCourse[]): {
    feedback: number;
    delinquent: number;
    missingPostNotification: number;
    pendingApproval: number;
  } {
    const counts = {
      feedback: 0,
      delinquent: 0,
      missingPostNotification: 0,
      pendingApproval: 0,
    };

    const today = this.toDateOnly(new Date());

    for (const course of courses ?? []) {
      const cancelled = course?.cancelled === true;
      if (cancelled) {
        continue;
      }

      if (this.isNonEmptyText((course as any)?.courseFeedback)) {
        counts.feedback += 1;
      }

      const daysSinceStart = this.daysSince((course as any)?.courseStart);
      const receivedPreNote = (course as any)?.receivedPreNote === true;
      const receivedPostNote = (course as any)?.receivedPostNote === true;
      const courseStartDate = (course as any)?.courseStart ? this.toDateOnly(new Date((course as any).courseStart)) : null;

      if (courseStartDate && courseStartDate.getTime() >= today.getTime() && receivedPreNote !== true) {
        counts.pendingApproval += 1;
      }

      if (!receivedPreNote || receivedPostNote || daysSinceStart === null) {
        continue;
      }

      if (daysSinceStart >= AtpEditComponent.delinquentDaysStart && daysSinceStart <= AtpEditComponent.delinquentDaysEnd) {
        counts.delinquent += 1;
      }

      if (daysSinceStart >= 0 && daysSinceStart < AtpEditComponent.delinquentDaysStart) {
        counts.missingPostNotification += 1;
      }
    }

    return counts;
  }

  private computeApplicationStatusCounts(applications: any[]): {
    feedback: number;
    pendingApproval: number;
    inProgress: number;
  } {
    const counts = {
      feedback: 0,
      pendingApproval: 0,
      inProgress: 0,
    };

    for (const application of applications ?? []) {
      const status = (application?.applicationStatus ?? '').toString();
      const hasFeedback = this.isNonEmptyText(application?.applicationFeedback);

      if (status === 'In Progress') {
        counts.inProgress += 1;
      }

      if (status === 'Submitted' && !hasFeedback) {
        counts.pendingApproval += 1;
      }

      if (hasFeedback && status !== 'Approved' && status !== 'Cancelled') {
        counts.feedback += 1;
      }
    }

    return counts;
  }

  private clearCourseFiltersForStatus(): void {
    this.filterATPCourseString = '';
    this.filterATPCourseDisciplines.setValue([]);
    this.filterATPCoursePreNote.setValue([]);
    this.filterATPCoursePostNote.setValue([]);
    this.filterATPCourseCancelled.setValue([]);
    this.courseStatusQuickFilter = null;
  }

  goToCourseStatus(status: 'feedback' | 'delinquent' | 'missingPostNotification' | 'pendingApproval'): void {
    // Tabs: 0=ATP Information, 1=Courses, 2=Accreditations, 3=Applications
    this.selectedTabIndex = 1;
    this.clearCourseFiltersForStatus();

    const today = this.toDateOnly(new Date());
    const addDays = (base: Date, days: number) => {
      const copy = new Date(base);
      copy.setDate(copy.getDate() + days);
      return copy;
    };

    if (status === 'feedback') {
      this.courseStatusQuickFilter = 'feedback';
      this.filterCourseTable();
      return;
    }

    if (status === 'pendingApproval') {
      this.courseStatusQuickFilter = 'pendingApproval';
      this.filterATPDateType.setValue('Course Start');
      this.filterStartDate = today;
      this.filterEndDate = null;
      this.filterATPCoursePreNote.setValue(['Not Received']);
      this.filterATPCourseCancelled.setValue(['Active']);
      this.filterCourseTable();
      return;
    }

    // For delinquent/missingPostNotification, align visible filters with the time window.
    this.filterATPDateType.setValue('Course Start');
    this.filterATPCoursePreNote.setValue(['Received']);
    this.filterATPCoursePostNote.setValue(['Not Received']);
    this.filterATPCourseCancelled.setValue(['Active']);

    if (status === 'delinquent') {
      this.courseStatusQuickFilter = 'delinquent';
      this.filterStartDate = addDays(today, -AtpEditComponent.delinquentDaysEnd);
      this.filterEndDate = addDays(today, -AtpEditComponent.delinquentDaysStart);
      this.filterCourseTable();
      return;
    }

    this.courseStatusQuickFilter = 'missingPostNotification';
    this.filterStartDate = addDays(today, -(AtpEditComponent.delinquentDaysStart - 1));
    this.filterEndDate = today;
    this.filterCourseTable();
  }

  goToApplicationStatus(status: 'feedback' | 'pendingApproval' | 'inProgress'): void {
    // Tabs: 0=ATP Information, 1=Courses, 2=Accreditations, 3=Applications
    this.selectedTabIndex = 3;
    if ((this.atpApplicationListComponent as any)?.applyQuickFilter) {
      (this.atpApplicationListComponent as any).applyQuickFilter(status);
    }
  }

  setAtpFormFields(){
    this.atpForm = new UntypedFormGroup(
      {
        name: new UntypedFormControl("", [Validators.required]), 
        nameAKA: new UntypedFormControl(""),
        atporId: new UntypedFormControl({value: "", disabled: true}),
        firm: new UntypedFormControl(""),
        rrpAccredStatus: new UntypedFormControl(""),
        lbpaAccredStatus: new UntypedFormControl(""),   
        privateCompany: new UntypedFormControl(false), 
        inactive: new UntypedFormControl(false), 
        outOfState: new UntypedFormControl(false), 
      }, 
      {
        validators: []
      }
    ); 
    this.addressForm = new UntypedFormGroup({
      street: new UntypedFormControl(""),
      city: new UntypedFormControl(""),
      state: new UntypedFormControl(""),
      zip: new UntypedFormControl("", [Validators.pattern(/^\d{5}(-\d{4})?$/)]),
      county: new UntypedFormControl(""),
    })
    this.contactForm = new UntypedFormGroup({               
      phone: new UntypedFormControl("", [Validators.pattern(/^\(?([0-9]{3})\)?-?([0-9]{3})-?([0-9]{4}).*$/)]),
      cell: new UntypedFormControl("", [Validators.pattern(/^\(?([0-9]{3})\)?-?([0-9]{3})-?([0-9]{4}).*$/)]),
      fax: new UntypedFormControl("", [Validators.pattern(/^\(?([0-9]{3})\)?-?([0-9]{3})-?([0-9]{4}).*$/)]),
      email: new UntypedFormControl("", [Validators.email]),        
      website: new UntypedFormControl(""),              
    });
  }

  loadATPFields(){
    for (const controlName in this.atp) {      
      if (this.atpForm.controls.hasOwnProperty(controlName)) {
        this.atpForm.controls[controlName].setValue(this.atp[controlName]);        
      }
    }
  }

  loadAddressFields(){
    for (const controlName in this.addressInformation) {
      if (this.addressForm.controls.hasOwnProperty(controlName)) {
        this.addressForm.controls[controlName].setValue(this.addressInformation[controlName]);
      }
    } 
  }

  loadContactFields(){
    for (const controlName in this.contactInformation) {
      if (this.contactForm.controls.hasOwnProperty(controlName)) {
        this.contactForm.controls[controlName].setValue(this.contactInformation[controlName]);
      }
    }         
  }

  updateAtp(): void {      
    for (const controlName in this.atp) {
      if (this.atpForm.controls.hasOwnProperty(controlName)) {
        this.atp[controlName] = this.atpForm.controls[controlName].value;                
      }
    }     
  }

  updateContactData(): void {
    for (const controlName in this.contactInformation) {
      if (this.contactForm.controls.hasOwnProperty(controlName)) {
        this.contactInformation[controlName] = this.contactForm.controls[controlName].value;        
      }
    } 
  }

  updateAddressData(): void {
    for (const controlName in this.addressInformation) {
      if (this.addressForm.controls.hasOwnProperty(controlName)) {
        this.addressInformation[controlName] = this.addressForm.controls[controlName].value;        
      }
    } 
  }

  saveAtp() {
    this.updateAtp();
    this.atpService.saveATP(this.atp).subscribe(result=>{
      this.atp.id = result.id
      this.toastr.success("Successfully saved ATP");
      
      this.updateAddressData();      
      this.commonService.saveAddress(this.addressInformation).subscribe(result=>{
        this.addressInformation.id = result.id
        if(this.atpAddressInformation.id === 0){
          this.atpAddressInformation.address = this.addressInformation;
          this.atpAddressInformation.atp = this.atp;
          this.atpService.saveATPAddress(this.atpAddressInformation).subscribe(result=>{
            this.atpAddressInformation.id = result.id
          },error=>{
            this.toastr.error("There was an error saving the atp address: ", error);
          })
        }
      },error=>{
        this.toastr.error("There was an error saving the address: ", error);
      });

      this.updateContactData();      
      this.commonService.saveContactInformation(this.contactInformation).subscribe(result=>{
        this.contactInformation.id = result.id;
        if(this.atpContactInformation.id === 0){
          this.atpContactInformation.contactInformation = this.contactInformation;
          this.atpContactInformation.atp = this.atp;
          this.atpService.saveATPContactInformation(this.atpContactInformation).subscribe(result=>{
            this.atpContactInformation.id = result.id
          },error=>{
            this.toastr.error("There was an error saving the atp contact information: ", error)
          })
        }
      },error=>{
        this.toastr.error("There was an error saving the contact information: ", error);
      });
    },error=>{
      this.toastr.error("An error occurred when trying to save the ATP: ", error);
    })    
  }

  refreshATPAddresses(){
    this.atpService.getAtpAddresses(this.atp.id).subscribe(result=>{        
      this.atpAddressInformation = result.length === 0 ? this.atpAddressInformation : result[0];
      this.addressInformation = this.atpAddressInformation.address;        
      this.loadAddressFields();
    },error=>{
      this.toastr.error("There was an error getting the ATP Address: ", error);
    }); 
  }

  refreshATPContactInformation(){
    this.atpService.getAtpContactInformation(this.atp.id).subscribe(result=>{             
      this.atpContactInformation = result ?? this.atpContactInformation;
      this.contactInformation = this.atpContactInformation.contactInformation;             
      this.loadContactFields();
    },error=>{
      this.toastr.error("There was an error getting the ATP Contact Information: ", error);
    }); 
  }
  
  refreshStaffMembers(){
    this.atpStaffLoading = true;
    this.atpService.getATPPeople(this.atp.id).subscribe(result=>{
      const staffRows = result || [];

      this.atpStaff = staffRows
        .filter(staff => staff?.isRequestOnly !== true && !!staff?.person?.id)
        .sort((a, b) => this.getStaffDisplayName(a?.person).localeCompare(this.getStaffDisplayName(b?.person)));

      this.atpStaffRows = [...staffRows].sort((a, b) => this.getStaffDisplayName(a?.person).localeCompare(this.getStaffDisplayName(b?.person)));
      this.filterStaffTable(); 
      this.atpStaffLoading = false;
    },error=>{
      this.toastr.error("There was an error getting the ATP People: ", error);
      this.atpStaffLoading = false;
    })
  }

  refreshCourses(){
    this.courseFilter.filterATPId = this.atp.id;
    this.courseFilter.filterDateType = this.filterATPDateType.value;
    this.courseFilter.filterStartDate = this.filterStartDate?.toISOString().substring(0,10);
    this.courseFilter.filterEndDate = this.filterEndDate?.toISOString().substring(0,10);

    this.atpCoursesLoading = true;
    this.atpService.getAtpFilteredCourses(this.courseFilter).subscribe(result=>{      
      this.atpCourses = result.map(course => ({
        ...course,
        location: ' \n' + course?.atpCourseAddress?.locationName + '\n' + 
                  course?.atpCourseAddress?.address?.street + '\n' + 
                  course?.atpCourseAddress?.address?.city + ', ' + 
                  course?.atpCourseAddress?.address?.state + ' ' + 
                  course?.atpCourseAddress?.address?.zip + '\n '
      })).sort((a, b) => new Date(b.courseStart).getTime() - new Date(a.courseStart).getTime());      
      this.refreshAtpStatusCounts();
      this.filterCourseTable();
      this.atpCoursesLoading = false;
    }, error=>{
      this.toastr.error("There was an error getting the ATP Courses: ", error)
    })
  }

  refreshAccreditation(){
    this.atpAccreditationLoading = true;
    this.atpService.getAtpAccreditations(this.atp.id).subscribe(result=>{
      this.atpAccreditation = result.sort((a, b) => new Date(b.applicationReceivedDate).getTime() - new Date(a.applicationReceivedDate).getTime());
      this.filterAccreditationTable();   
      this.atpAccreditationLoading = false;
      this.preloadApplicationTargetContext();
    }, error=>{
      this.atpAccreditationLoading = false;
      this.toastr.error("There was an error getting the ATP Accreditations: ", error)
    })
  }

  setDefaultCourseFilters(){
    this.filterStartDate = new Date(new Date().setMonth(new Date().getMonth() - 6));
    this.filterEndDate = null;
    this.filterATPCourseString = '';
    this.filterATPCourseDisciplines.setValue([]);
    this.filterATPCoursePreNote.setValue([]);
    this.filterATPCoursePostNote.setValue([]);
    this.filterATPCourseCancelled.setValue([]);
    this.courseStatusQuickFilter = null;

    this.refreshCourses();
  }

  filterCourseTable(): void {
    this.atpCourseTable.layout.data = this.atpCourses;
    
    this.atpCourseTable.layout.data = this.atpCourseTable.layout.data.filter(x => {      
      return ( x.id?.toString().includes(this.filterATPCourseString) || 
      x.location?.toLowerCase().includes(this.filterATPCourseString.toLowerCase()) || x.stage?.toLowerCase().includes(this.filterATPCourseString.toLowerCase())
    )});

    if(this.filterATPCourseDisciplines.value.length > 0){
      this.atpCourseTable.layout.data = this.atpCourseTable.layout.data.filter(x => this.filterATPCourseDisciplines.value.includes(x.accreditationDiscipline));
    }

    if(this.filterATPCoursePreNote.value.length > 0){
      this.atpCourseTable.layout.data = this.atpCourseTable.layout.data.filter(x => 
          (this.filterATPCoursePreNote.value.includes('Not Received') && x.receivedPreNote === false) ||
          (this.filterATPCoursePreNote.value.includes('Received') && x.receivedPreNote === true)
      );
    }

    if(this.filterATPCoursePostNote.value.length > 0){
      this.atpCourseTable.layout.data = this.atpCourseTable.layout.data.filter(x => 
          (this.filterATPCoursePostNote.value.includes('Not Received') && x.receivedPostNote === false) ||
          (this.filterATPCoursePostNote.value.includes('Received') && x.receivedPostNote === true)
      );
    }

    if(this.filterATPCourseCancelled.value.length > 0){
      this.atpCourseTable.layout.data = this.atpCourseTable.layout.data.filter(x => 
          (this.filterATPCourseCancelled.value.includes('Cancelled') && x.cancelled === true) ||
          (this.filterATPCourseCancelled.value.includes('Active') && x.cancelled === false)
      );
    }

    if (this.courseStatusQuickFilter) {
      const today = this.toDateOnly(new Date());
      this.atpCourseTable.layout.data = this.atpCourseTable.layout.data.filter(course => {
        if (course?.cancelled === true) {
          return false;
        }

        if (this.courseStatusQuickFilter === 'feedback') {
          return this.isNonEmptyText((course as any)?.courseFeedback);
        }

        const receivedPreNote = (course as any)?.receivedPreNote === true;
        const receivedPostNote = (course as any)?.receivedPostNote === true;
        const startDate = (course as any)?.courseStart ? this.toDateOnly(new Date((course as any).courseStart)) : null;
        const daysSinceStart = this.daysSince((course as any)?.courseStart);

        if (this.courseStatusQuickFilter === 'pendingApproval') {
          return startDate && startDate.getTime() >= today.getTime() && receivedPreNote !== true;
        }

        if (!receivedPreNote || receivedPostNote || daysSinceStart === null) {
          return false;
        }

        if (this.courseStatusQuickFilter === 'delinquent') {
          return daysSinceStart >= AtpEditComponent.delinquentDaysStart && daysSinceStart <= AtpEditComponent.delinquentDaysEnd;
        }

        return daysSinceStart >= 0 && daysSinceStart < AtpEditComponent.delinquentDaysStart;
      });
    }
    
    this.updateCourseDataSource();
  }
  editCourse(row: any): void {    
    const dialogRef = this.dialog.open(AtpEditCourseComponent, {        
      data: {course:null, atp:this.atp, atpStaff: this.atpStaff, courseId: row?.id},
      width: '90%',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {          
      this.refreshCourses();      
    });
  }
  updateCourseDataSource(){    
    this.atpCourseDataSource = new MatTableDataSource<any>(this.atpCourseTable.layout.data);
    this.atpCourseDataSource.paginator = this.atpCoursePaginator;
    this.atpCourseDataSource.sort = this.atpCourseSort;    
  }

  filterStaffTable(): void {
    this.atpStaffTable.layout.data = this.atpStaffRows.map(staff=>{return {
        ...staff.person,
      affiliationId: staff?.id || 0,
        personId: staff?.person?.id || null,
        isRequestOnly: staff?.isRequestOnly === true,
        requestStatus: this.normalizeStaffRequestStatus(staff?.requestStatus),
        isContact: staff.isContact,
        isInstructor: staff.isInstructor,
        isPrimaryInstructor: staff.isPrimaryInstructor,
        isTrainingManager: staff.isTrainingManager,
      };
    })
    this.atpStaffTable.layout.data.forEach(person=>{person.displayName = this.getStaffDisplayName(person);})

    this.atpStaffTable.layout.data = this.atpStaffTable.layout.data.filter(x => {      
      return x.displayName?.toString().toLowerCase().includes(this.filterATPStaffString.toLowerCase())        
    });

    if(this.filterATPStaffPOC.value.length > 0){
      this.atpStaffTable.layout.data = this.atpStaffTable.layout.data.filter(x => 
          (this.filterATPStaffPOC.value.includes('Unchecked') && x.isContact === false) ||
          (this.filterATPStaffPOC.value.includes('Checked') && x.isContact === true)
      );
    }

    if(this.filterATPStaffInstructor.value.length > 0){
      this.atpStaffTable.layout.data = this.atpStaffTable.layout.data.filter(x => 
          (this.filterATPStaffInstructor.value.includes('Unchecked') && x.isInstructor === false) ||
          (this.filterATPStaffInstructor.value.includes('Checked') && x.isInstructor === true)
      );
    }

    if(this.filterATPStaffPrimaryInstructor.value.length > 0){
      this.atpStaffTable.layout.data = this.atpStaffTable.layout.data.filter(x => 
          (this.filterATPStaffPrimaryInstructor.value.includes('Unchecked') && x.isPrimaryInstructor === false) ||
          (this.filterATPStaffPrimaryInstructor.value.includes('Checked') && x.isPrimaryInstructor === true)
      );
    }

    if(this.filterATPStaffTrainingManager.value.length > 0){
      this.atpStaffTable.layout.data = this.atpStaffTable.layout.data.filter(x => 
          (this.filterATPStaffTrainingManager.value.includes('Unchecked') && x.isTrainingManager === false) ||
          (this.filterATPStaffTrainingManager.value.includes('Checked') && x.isTrainingManager === true)
      );
    }
    this.updateStaffDataSource();
  }
  updateStaffDataSource(){    
    this.atpStaffDataSource = new MatTableDataSource<any>(this.atpStaffTable.layout.data);
    this.atpStaffDataSource.paginator = this.atpStaffPaginator;
    this.atpStaffDataSource.sort = this.atpStaffSort;    
  }
  editStaff(row: any): void {
    if (!row || row.isRequestOnly === true) {
      return;
    }

    const selectedStaff = this.atpStaff.find(staff => staff?.person?.id === row?.personId || staff?.person?.id === row?.id);
    if (!selectedStaff) {
      return;
    }

    const dialogRef = this.dialog.open(AtpEditStaffComponent, {        
      data: {currentPeople: this.atpStaff.map(staff => staff.person), atp: this.atp, person: selectedStaff},
      width: this.isMobile ? '90%' : '30%',
      autoFocus: false,});
    dialogRef.afterClosed().subscribe(result => {    
      if (result){        
        this.refreshStaffMembers();
      }    
    });
  }

  openAddStaffRequestDialog(): void {
    const existingPersonIds = this.atpStaffRows
      .map(staff => staff?.person?.id)
      .filter(personId => !!personId);

    const dialogRef = this.dialog.open(StaffAffiliationRequestDialogComponent, {
      width: this.isMobile ? '95%' : '45%',
      autoFocus: false,
      data: {
        title: 'Add ATP Staff',
        existingPersonIds,
      },
    });

    dialogRef.afterClosed().subscribe((selectedPerson) => {
      if (!selectedPerson?.id) {
        return;
      }

      this.atpService.requestATPStaffAffiliation(this.atp.id, selectedPerson.id).subscribe({
        next: (response) => {
          if (response?.success === false) {
            this.toastr.info(response?.message || 'This person is already affiliated to this ATP.');
            this.refreshStaffMembers();
            return;
          }

          this.toastr.success('Staff affiliation approval request sent.');
          this.refreshStaffMembers();
        },
        error: (error) => {
          this.toastr.error('There was an error requesting ATP staff affiliation: ', error);
        }
      });
    });
  }

  cancelStaffAffiliationRequest(row: any): void {
    const personId = row?.personId || row?.id;
    if (!personId) {
      return;
    }

    this.atpService.cancelATPStaffAffiliationRequest(this.atp.id, personId).subscribe({
      next: (response) => {
        if (response?.success) {
          this.toastr.success('Staff affiliation request removed.');
        } else {
          this.toastr.info('No active staff affiliation request was found.');
        }

        this.refreshStaffMembers();
      },
      error: (error) => {
        this.toastr.error('There was an error removing ATP staff affiliation request: ', error);
      }
    });
  }

  deleteStaffAffiliation(row: any): void {
    if (!row) {
      return;
    }

    if (row.isRequestOnly === true) {
      this.cancelStaffAffiliationRequest(row);
      return;
    }

    const affiliationId = row?.affiliationId;
    if (!affiliationId) {
      this.toastr.error('Unable to remove staff affiliation.');
      return;
    }

    const fullName = this.getStaffDisplayName(row);
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',
      data: {
        message: 'Are you sure you want to <strong>Remove</strong> staff affiliation for <strong>' + fullName + '</strong>?',
        title: 'Remove ATP Staff Affiliation',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.atpService.deleteATPPerson(affiliationId).subscribe({
        next: () => {
          this.toastr.success('Staff affiliation removed successfully.');
          this.refreshStaffMembers();
        },
        error: (error) => {
          this.toastr.error('There was an error removing ATP staff affiliation: ', error);
        }
      });
    });
  }

  canEditStaffRow(row: any): boolean {
    return row?.isRequestOnly !== true;
  }

  getStaffRowClass(row: any): string {
    const status = this.normalizeStaffRequestStatus(row?.requestStatus);
    if (status === 'Pending') {
      return 'affiliation-status-pending';
    }

    if (status === 'Denied') {
      return 'affiliation-status-denied';
    }

    return '';
  }

  getStaffStatusClass(row: any): string {
    const status = this.normalizeStaffRequestStatus(row?.requestStatus);
    if (status === 'Pending') {
      return 'affiliation-status-pending';
    }

    if (status === 'Denied') {
      return 'affiliation-status-denied';
    }

    return '';
  }

  private getStaffDisplayName(person: any): string {
    const firstName = (person?.firstName || '').toString().trim();
    const middleName = (person?.middleName || '').toString().trim();
    const lastName = (person?.lastName || '').toString().trim();
    const fullName = [firstName, middleName, lastName].filter(namePart => namePart.length > 0).join(' ');
    return fullName || 'Unknown Person';
  }

  private normalizeStaffRequestStatus(value: string | null | undefined): string {
    const normalizedValue = (value || '').toString().trim().toLowerCase();
    if (normalizedValue === 'pending') {
      return 'Pending';
    }

    if (normalizedValue === 'denied') {
      return 'Denied';
    }

    return '';
  }

  onShowHistoryChange(event: any): void {
    this.showHistory = event.checked;
    this.filterAccreditationTable();
  }

  applyAccreditationFilter(): void {
    if (this.atpAccreditationDataSource) {
      this.atpAccreditationDataSource.filter = this.filterATPAccreditationString.trim().toLowerCase();
    }
  }

  filterAccreditationTable(): void {    
    this.atpAccreditationTable.layout.data = this.atpAccreditation;

    if (!this.showHistory) {
      this.atpAccreditationTable.layout.data = this.atpAccreditationTable.layout.data
        .reduce((acc, curr) => {              
          const existing = acc.find(x => x.accreditationEndorsementType === curr.accreditationEndorsementType);
          if (!existing) {
            acc.push(curr);
          } else if (new Date(curr.expirationDate) > new Date(existing.expirationDate)) {
              const index = acc.indexOf(existing);
              acc[index] = curr;
          }
          return acc;
        }, []);
    }

    if (this.filterAccreditationStartDate) {     
      this.atpAccreditationTable.layout.data = this.atpAccreditationTable.layout.data.filter(x => new Date(x.expirationDate) >= this.filterAccreditationStartDate);
    }

    if (this.filterAccreditationEndDate) {
      this.atpAccreditationTable.layout.data = this.atpAccreditationTable.layout.data.filter(x => new Date(x.expirationDate) <= this.filterAccreditationEndDate);
    } 

    this.updateAccreditationDataSource();
  }
  updateAccreditationDataSource(){    
    this.atpAccreditationDataSource = new MatTableDataSource<any>(this.atpAccreditationTable.layout.data);
    this.atpAccreditationDataSource.paginator = this.atpAccreditationPaginator;
    this.atpAccreditationDataSource.sort = this.atpAccreditationSort;
    
    // Apply the filter string if it exists
    if (this.filterATPAccreditationString) {
      this.atpAccreditationDataSource.filter = this.filterATPAccreditationString.trim().toLowerCase();
    }
  }

  isRenewalEligible(expirationDate: any): boolean {
    if (!expirationDate) {
      return false;
    }

    const expDate = new Date(expirationDate);
    const today = new Date();
    
    // Calculate the date 6 months from today
    const sixMonthsFromNow = new Date();
    sixMonthsFromNow.setMonth(today.getMonth() + 6);
    
    // Enable renewal if expiration date is within 6 months (past or future)
    // This means: expiration date <= 6 months from now
    return expDate <= sixMonthsFromNow;
  }

  isExpired(expirationDate: any): boolean {
    if (!expirationDate) {
      return true;
    }

    const expDate = this.toDateOnly(new Date(expirationDate));
    const today = this.toDateOnly(new Date());
    return expDate < today;
  }

  isAmmendmentEligible(expirationDate: any): boolean {
    if (!expirationDate) {
      return false;
    }

    const expDate = this.toDateOnly(new Date(expirationDate));
    const sixMonthsFromNow = this.toDateOnly(new Date());
    sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);
    return expDate > sixMonthsFromNow;
  }

  renewAccreditation(row: any): void {
    // Open ATP application dialog for renewal
    const dialogRef = this.dialog.open(AtpApplicationComponent, this.sharedService.getWizardDialogConfig({
      disableClose: false,
      data: {
        atpId: this.atp.id,
        atp: this.atp,
        atpStaff: this.atpStaff,
        renewalAccreditation: row,
        targetContext: this.applicationTargetContext
      }
    }));

    dialogRef.afterClosed().subscribe(result => {
      if (result) {        
        // Refresh the application list
        if (this.atpApplicationListComponent) {
          this.atpApplicationListComponent.loadData();
        }
        // Refresh accreditations to update button states
        this.refreshAccreditation();
      }
    });
  }

  ammendAccreditation(row: any): void {
    const dialogRef = this.dialog.open(AtpApplicationComponent, this.sharedService.getWizardDialogConfig({
      disableClose: false,
      data: {
        atpId: this.atp.id,
        atp: this.atp,
        atpStaff: this.atpStaff,
        ammendmentAccreditation: row,
        targetContext: this.applicationTargetContext
      }
    }));

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.atpApplicationListComponent) {
          this.atpApplicationListComponent.loadData();
        }
        this.refreshAccreditation();
      }
    });
  }

  startNewApplication(): void {
    const dialogRef = this.dialog.open(AtpApplicationComponent, this.sharedService.getWizardDialogConfig({
      data: {
        atpApplicationId: null,
        atpId: this.atp.id,
        atp: this.atp,
        atpStaff: this.atpStaff,
        targetContext: this.applicationTargetContext
      }
    }));

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.atpApplicationListComponent) {
          this.atpApplicationListComponent.loadData();
        }

        this.refreshAccreditation();
      }
    });
  }

  // Determine if accreditation has a valid (non-cancelled) application
  hasValidApplication(accreditation: any): boolean {
    return accreditation.atpApplicationId && 
           accreditation.atpApplicationId !== 0;
  }

  // View existing application instead of creating renewal
  viewApplication(accreditation: any): void {
    if (!accreditation.atpApplicationId || accreditation.atpApplicationId === 0) {
      this.toastr.warning('No valid application found');
      return;
    }

    const dialogRef = this.dialog.open(AtpApplicationComponent, this.sharedService.getWizardDialogConfig({
      disableClose: false,
      data: {
        atpApplicationId: accreditation.atpApplicationId,
        atpId: this.atp.id,
        atp: this.atp,
        atpStaff: this.atpStaff
      }
    }));

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh the application list
        if (this.atpApplicationListComponent) {
          this.atpApplicationListComponent.loadData();
        }
        // Refresh accreditations to update button states
        this.refreshAccreditation();
      }
    });
  }

  refreshUserAccounts(){
    this.atpService.getAtpUsers(this.atp.id).subscribe(result=>{
      this.userAccounts = result;
      this.updateUserAccountDataSource();
    }, error=>{
      this.toastr.error("There was an error getting the ATP User Accounts: ", error)
    })
  }

  applyUserAccountFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.userAccountsDataSource.filter = filterValue.trim().toLowerCase();

    if (this.userAccountsDataSource.paginator) {
      this.userAccountsDataSource.paginator.firstPage();
    }
  }

  updateUserAccountDataSource(){
    // Sort user accounts: pending requests first, then active, then inactive
    const sortedAccounts = [...this.userAccounts].sort((a, b) => {
      const aHasPendingRequest = a.status !== a.requestedStatus;
      const bHasPendingRequest = b.status !== b.requestedStatus;
      const aIsInactive = a.status === 'Inactive' && a.requestedStatus === 'Inactive';
      const bIsInactive = b.status === 'Inactive' && b.requestedStatus === 'Inactive';

      // Pending requests first
      if (aHasPendingRequest && !bHasPendingRequest) return -1;
      if (!aHasPendingRequest && bHasPendingRequest) return 1;

      // Inactive last (only if both don't have pending requests)
      if (!aHasPendingRequest && !bHasPendingRequest) {
        if (aIsInactive && !bIsInactive) return 1;
        if (!aIsInactive && bIsInactive) return -1;
      }

      return 0;
    });

    this.userAccountsDataSource = new MatTableDataSource<any>(sortedAccounts);
    this.userAccountsDataSource.paginator = this.userAccountPaginator;
    this.userAccountsDataSource.sort = this.userAccountSort;    
  }

  toggleUserAccountRequestedStatus(row: any): void {
    const newRequestedStatus = row.requestedStatus === 'Active' ? 'Inactive' : 'Active';
    const action = newRequestedStatus === 'Active' ? 'Activate' : 'Deactivate';
    
    const affiliation: IAccountAffiliation = {
      id: row.id,
      userId: row.userID,
      firm: row.firm,
      atp: row.atp,
      status: row.status,
      requestedStatus: newRequestedStatus,
      person: row.person,
      lastUpdatedBy: row.lastUpdatedBy,
      userName: row.userName
    };

    this.commonService.saveAccountAffiliation(affiliation).subscribe(
      result => {
        this.toastr.success(`${action} request submitted successfully`);
        this.refreshUserAccounts();
      },
      error => {
        this.toastr.error(`Error submitting ${action.toLowerCase()} request: `, error);
      }
    );
  }

  getRowClass(row: any): string {
    if (row.status !== row.requestedStatus) {
      return 'pending-request-row';
    }
    if (row.status === 'Inactive') {
      return 'inactive-row';
    }
    return '';
  }

  shouldShowRequestedBy(row: any): boolean {
    return row.status !== row.requestedStatus;
  }
}
